module.exports = __webpack_public_path__ + "assets/img/pj_panda_fist_bump.1b2d016f.png";